import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import { Reload, OutlineButton, Confirm } from 'libs/ui';
import { OptionReceipt } from './option-receipt/option-receipt';
import { Wrapper, Content, Buttons } from './options.styled';

export const OptionsApp = ({ id }) => {
  const { t } = useTranslation();
  const status = useSelector((store) => store.equipment[id] ?? {});
  const [confirm, setConfirm] = useState(false);
  const [confirm1, setConfirm1] = useState(false);
  const closed = status.flags ? status.flags.includes('cash_register.shift_closed') : true;
  const { mode } = status;
  const offline = mode === 'offline';

  const rightShift = window.haveRight('mnemo.shift');

  /**
   * send socket msg
   * @param {*} message
   * @param {*} params
   */
  const sendControlMsg = (message, params) => {
    const data = Object.assign({ target: id, user_id: user.getId() }, params);
    socket.call(message, data);
  };

  // update state
  useEffect(() => {
    sendControlMsg('get_state');
  }, []);

  const showConfirm = () => {
    setConfirm(true);
    setConfirm1(false);
  };

  const showConfirm1 = () => {
    setConfirm(false);
    setConfirm1(true);
  };

  const closeConfirm = () => {
    setConfirm(false);
    setConfirm1(false);
  };

  const reconciliation = () => {
    sendControlMsg('reconciliation');
    closeConfirm();
  };

  const closeShift = () => {
    sendControlMsg('zreport_to_buffer');
    setConfirm(false);
    sendControlMsg('get_state');
  };

  let cl2 = offline || !mode ? 'offline1' : '';
  const withReceipt = user.haveRight('receipt_template.edit');

  return (
    <Wrapper>
      <Content className={cl2}>
        <Buttons>
          <div>
            <OutlineButton disabled={!rightShift || closed || confirm} className="btn field" onClick={showConfirm}>
              {t('buttons.Закрыть смену')}
            </OutlineButton>
            {confirm && (
              <Confirm
                close={closeConfirm}
                action={closeShift}
                title={t('windows.Кассовая смена будет закрыта. Продолжить?')}
                actionTitle={<>&nbsp; &nbsp; {t('buttons.Ок')} &nbsp; &nbsp;</>}
              />
            )}
          </div>
          <div>
            <OutlineButton disabled={confirm1} className="btn field" onClick={showConfirm1}>
              {t('buttons.Сверка итогов')}
            </OutlineButton>
            {confirm1 && (
              <Confirm
                close={closeConfirm}
                action={reconciliation}
                title={t('windows.Провести сверку итогов?')}
                actionTitle={<>&nbsp; &nbsp; {t('buttons.Ок')} &nbsp; &nbsp;</>}
              />
            )}
          </div>
        </Buttons>

        {withReceipt && <OptionReceipt className="is-app" sendControlMsg={sendControlMsg} templateId={status?.printer?.receipt_template_id} />}

        <Reload id={id} sendControlMsg={sendControlMsg} />
      </Content>
    </Wrapper>
  );
};
